// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueMoment from 'vue-moment'
import VeeValidate from 'vee-validate'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'
import store from './store'
import Toast from 'vue2-toast'

import 'vue2-toast/lib/toast.css'
import 'vuetify/dist/vuetify.min.css'
import 'font-awesome/css/font-awesome.css'

Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(Vuetify)
Vue.use(VueMoment)
Vue.use(VeeValidate)
Vue.use(Toast)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js